import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Popup, Form, Grid, TextArea, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import FileLoader from '../../../../common/components/fileUpload';
import AttachMessage from './message';
import {canDownload} from './utils';
import ZoomImage from './zoomImage';

class Attachments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isOpen': false,
      'attachment': null,
      'description': '',
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClearFile = this.handleClearFile.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  handleOpen() {
    this.setState({
      'isOpen': true,
      'attachment': null,
      'description': '',
    });
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  handleDescriptionChange(event, {name, value}) {
    this.setState({[name]: value});
  }

  handleFileUpload(event) {
    const files = event.target.files;
    
    if (files.length) {
      this.setState({'attachment': files[0]});
    }
  }

  handleClearFile() {
    this.setState({'attachment': null});
  }

  handleDelete(attachmentCode) {
    const {currentClaim} = this.props;
    this.props.removeReturnClaimAttachment(currentClaim.code, attachmentCode);
  }

  handleClick() {
    const {currentClaim} = this.props;
    const {attachment, description} = this.state;

    if (attachment) {
      const data = new FormData();
      data.append('attachment', attachment);
      data.append('description', description);

      this.props.addNewReturnClaimAttachment(currentClaim.code, data);
      this.setState({'attachment': null, 'description': ''});
    }
  }

  renderLoader() {
    if (this.props.attaching) {
      return (
        <Grid.Row>
          <Grid.Column width='16' textAlign='center'>
            <Icon loading name='spinner' size='huge' />
          </Grid.Column>
        </Grid.Row>
      );
    }

    return null;
  }

  renderDeleteIcon(attachmentCode) {
    if (this.props.returnOrder.status !== 'I') {
      return null;
    }

    return (
      <Popup inverted
        content='Eliminar adjunto'
        trigger={
          <Icon link name='close' color='red' size='large' onClick={() => this.handleDelete(attachmentCode)} />
        }
      />
    );
  }

  renderEditSection() {
    const {attaching, returnOrder, currentClaim} = this.props;
    const {attachments = []} = currentClaim;

    if (attaching || returnOrder.status !== 'I' || attachments.length >= 5) {
      return null;
    }

    return (
      <React.Fragment>
        <Grid.Row>
          <Grid.Column width='6'>
            <label><strong>Archivo</strong></label>
            <br />
            {this.renderFileLoader()}
          </Grid.Column>
          <Grid.Column width='10'>
            <label><strong>Descripción</strong></label>
            <TextArea
              name='description'
              maxLength='300'
              rows='3'
              value={this.state.description}
              onChange={this.handleDescriptionChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width='16' textAlign='right'>
            <Button primary
              type='button'
              content='ADJUNTAR'
              disabled={!this.state.attachment || !this.state.description}
              onClick={this.handleClick}
            />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }

  renderAttachments() {
    const {currentClaim, attaching} = this.props;
    const {attachments = []} = currentClaim;

    if (attaching) {
      return null;
    }

    if (!attachments.length) {
      return (
        <Grid.Row>
          <Grid.Column width='16' textAlign='center'>
            No se encontraron archivos adjuntos.
          </Grid.Column>
        </Grid.Row>
      );
    }

    return attachments.map((attachment) => {
      if (attachment.fileType !== 'IMAGEN') {
        let attachmentLink;
        if (!canDownload(attachment.path)) {
          attachmentLink = <div>{attachment.description || attachment.filename}</div>;
        } else {
          attachmentLink = <div>
            <a href={attachment.path} target='_blank' rel="noreferrer">
              {attachment.description || attachment.filename}
            </a>
          </div>;
        }
        return (
          <Grid.Row key={attachment.code}>
            <Grid.Column width='4' textAlign='left'>
              <Icon name='file' size='massive' />
            </Grid.Column>
            <Grid.Column width='11' textAlign='left'>
              <label><strong>Descripción</strong></label>
              {attachmentLink}
            </Grid.Column>
            <Grid.Column width='1' textAlign='right'>
              {this.renderDeleteIcon(attachment.code)}
            </Grid.Column>
          </Grid.Row>
        );
      }
      console.log('image');
      console.log('path: ', attachment.path);
      return (
        <Grid.Row key={attachment.code}>
          <Grid.Column width='4' textAlign='left'>
            <ZoomImage image={attachment.path} />
          </Grid.Column>
          <Grid.Column width='11' textAlign='left'>
            <label><strong>Descripción</strong></label>
            <div>{attachment.description || attachment.filename}</div>
          </Grid.Column>
          <Grid.Column width='1' textAlign='right'>
            {this.renderDeleteIcon(attachment.code)}
          </Grid.Column>
        </Grid.Row>
      );
    });
  }

  renderFileLoader() {
    if (this.state.attachment) {
      return (
        <Button secondary onClick={this.handleClearFile}>
          <Icon name='cancel' color='red' />
          {this.state.attachment.name}
        </Button>
      );
    }

    return (
      <FileLoader icon
        text='SELECCIONAR'
        changeActions={this.handleFileUpload}
      />
    );
  }

  render() {
    const {returnOrder} = this.props;

    if (!returnOrder) {
      return null;
    }

    return (
      <Modal closeIcon
        open={this.state.isOpen}
        onClose={this.handleClose}
        trigger={
          <span>
            <Popup inverted
              content='Adjuntos'
              trigger={<Icon link size='large' name='file' onClick={this.handleOpen} />}
            />
          </span>
        }
      >
        <Modal.Header>Archivos Adjuntos</Modal.Header>
        <Modal.Content>
          <AttachMessage />
          <Form>
            <Grid>
              {this.renderLoader()}
              {this.renderAttachments()}
              {this.renderEditSection()}
            </Grid>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'attaching': state.returnClaim.attaching,
  };
};

const {
  addNewReturnClaimAttachment,
  removeReturnClaimAttachment,
} = Actions;

export default connect(mapStateToProps, {
  addNewReturnClaimAttachment,
  removeReturnClaimAttachment,
})(Attachments);
